<template>
  <div id="app">
    <router-view :key="$route.query.columnId"/>
  </div>
</template>
<script>
import weixinJSSDK from '@/utils/js/weixin.js';

export default {
  data () {
    return {}
  },
  mounted() {
    window.addEventListener('beforeunload', this.closeMask);
    this.$once('hook:beforeDestroy', this.closeMask);
  },
  destroyed() {
    this.closeMask();
  },
  methods: {
    closeMask () {
      sessionStorage.removeItem('banner');
      sessionStorage.removeItem('reportList');
      sessionStorage.removeItem('documentList');
    }
  },
  watch: {
    $route(to, from) {
      // 路由变化时重新设置分享数据（如果需要动态设置）
      setTimeout(() => {
        if (window.wx) {
          // 延迟执行以确保页面内容更新完成
          this.$nextTick(() => {
            // 可以在这里根据当前路由动态更新分享内容
            weixinJSSDK.setShareData();
          });
        }
      }, 100);
    }
  }
}
</script>
<style>
@import "./style/common.css";
</style>